import React from 'react';
import cn from 'classnames';

import prev from './arrow-prev.img.svg';
import next from './arrow-next.img.svg';
import s from './sliderArrowControls.module.scss';


type Direction = 'prev' | 'next';

type SliderArrowControlsProps = {
    // eslint-disable-next-line no-unused-vars
    handleClickSlideArrow: (direction: Direction) => void
};


export function SliderArrowControls({
    handleClickSlideArrow,
}: SliderArrowControlsProps) {
    return (
        <div>
            <button
                type="button"
                className={cn([s.sliderArrowControl, s.sliderArrowControlPrev])}
                onClick={() => handleClickSlideArrow('prev')}
            >
                <img src={prev} alt="prev" />
            </button>
            <button
                type="button"
                className={cn([s.sliderArrowControl, s.sliderArrowControlNext])}
                onClick={() => handleClickSlideArrow('next')}
            >
                <img src={next} alt="next" />
            </button>
        </div>
    );
}
